/* The Lift Society landing page — count-up stats, testimonial marquee, launch mode. */
(function(){
  if(window.__liftSociety) return; window.__liftSociety=true;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(){
    /* launch mode (also set inline by the hero to avoid a flash) */
    var m=document.querySelector('[data-ls-mode]');
    if(m){var mode=m.getAttribute('data-ls-mode'),t=Date.parse(m.getAttribute('data-ls-launch'));
      document.documentElement.classList.toggle('ls-open',mode==='open'||(mode==='auto'&&!isNaN(t)&&Date.now()>=t));}

    /* count up */
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return; io.unobserve(e.target);
        var el=e.target,target=parseFloat(el.dataset.count)||0,suf=el.dataset.suffix||'';
        var fmt=function(v){return Math.round(v).toLocaleString('en-AU')+suf;};
        if(reduce){el.textContent=fmt(target);return;}
        var s=null;(function f(ts){if(!s)s=ts;var k=Math.min((ts-s)/1400,1),q=1-Math.pow(1-k,3);el.textContent=fmt(target*q);if(k<1)requestAnimationFrame(f);})(performance.now());
      });
    },{threshold:.5});
    document.querySelectorAll('.ls [data-count]').forEach(function(el){io.observe(el);});

    /* testimonials: a native horizontal scroller that drifts on its own.
       Touch, trackpad and keyboard scrolling work normally; drifting pauses while
       someone is interacting, on hover/focus, with the Pause button, and off screen. */
    document.querySelectorAll('.ls .voices').forEach(function(v){
      var m=v.querySelector('.marquee'),t=v.querySelector('.mq-track'),b=v.querySelector('.mq-pause');
      if(b){
        var labels=[b.getAttribute('data-pause')||'Pause',b.getAttribute('data-play')||'Play'];
        b.addEventListener('click',function(){var p=v.classList.toggle('is-paused');b.setAttribute('aria-pressed',p);b.querySelector('span').textContent=p?labels[1]:labels[0];});
      }
      if(!m||!t||reduce) return;
      var originals=[].slice.call(t.children);
      originals.forEach(function(c){var k=c.cloneNode(true);k.setAttribute('aria-hidden','true');k.setAttribute('inert','');t.appendChild(k);});
      var firstClone=t.children[originals.length];
      function period(){return firstClone.offsetLeft-originals[0].offsetLeft;}
      var dur=parseFloat(getComputedStyle(m).getPropertyValue('--mq-dur'))||150;
      var pos=0,last=0,hold=false,holdTimer=null,hover=false,visible=true,ours=false;
      function holdFor(ms){hold=true;clearTimeout(holdTimer);holdTimer=setTimeout(function(){hold=false;pos=m.scrollLeft;},ms);}
      function wrap(){var p=period();if(p<=0)return;if(m.scrollLeft>=p){ours=true;m.scrollLeft-=p;}else if(m.scrollLeft<=0&&hold){ours=true;m.scrollLeft+=p;}pos=m.scrollLeft;}
      m.addEventListener('pointerdown',function(){holdFor(60000);});
      ['pointerup','pointercancel','touchend'].forEach(function(e){m.addEventListener(e,function(){holdFor(2500);},{passive:true});});
      m.addEventListener('wheel',function(){holdFor(2500);},{passive:true});
      m.addEventListener('keydown',function(){holdFor(4000);});
      m.addEventListener('mouseenter',function(){hover=true;});
      m.addEventListener('mouseleave',function(){hover=false;pos=m.scrollLeft;});
      m.addEventListener('focusin',function(){hover=true;});
      m.addEventListener('focusout',function(){hover=false;pos=m.scrollLeft;});
      m.addEventListener('scroll',function(){if(ours){ours=false;return;}if(hold)wrap();},{passive:true});
      new IntersectionObserver(function(es){visible=es[0].isIntersecting;}).observe(m);
      (function step(ts){
        var dt=last?Math.min(ts-last,100):0;last=ts;
        if(visible&&!hold&&!hover&&!v.classList.contains('is-paused')){
          var p=period();
          pos+=p/dur*dt/1000; if(p>0&&pos>=p) pos-=p;
          ours=true; m.scrollLeft=pos;
        }
        requestAnimationFrame(step);
      })(0);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
